<template>
  <a-upload
    :showUploadList="false"
    accept=".srt,.vtt"
    name="file"
    :customRequest="handleChangeEn"
  >
<!--    <a-upload-dragger-->
<!--      name="file"-->
<!--      accept=".srt,.vtt"-->
<!--      :multiple="true"-->
<!--      :show-upload-list="false"-->
<!--      :customRequest="handleChangeZh"-->
<!--    >-->
    <a-button type="primary" v-if="customType == 1 ? customInfo.subtitleCn :
    customType == 2 ? customInfo.subtitle :
    customType == 3 ? customInfo.subtitleEn : customType == 4 ? customInfo.subtitleBm : customInfo.subtitleIn">更换</a-button>
    <a-button v-else> <a-icon type="upload" /> 上传 </a-button>
<!--    </a-upload-dragger>-->
  </a-upload>
</template>

<script>
import {updateGather} from "@/api/shortVideo/video/gather";
// import UploadFileToVOD from "@/api/shortVideo/vod";
import UploadFileToVOD from '@/api/shortVideo/vod'
export default {
  name: "gatherUploadBtn",
  props:{
    customInfo:{
      type:Object,
    },
    customIndex:{
      type:Number
    },
    customType:{
      type:Number
    }
  },

  methods:{
    handleChangeEn(info) {
      console.log(info);
      console.log('------------');
      // return;
      // var fileType = info.file.name;
      // if (fileType.indexOf('vtt') < 0) {
      //   this.$message.warning('请上传vtt文件');
      // }
      // if(this.customType == 1) {
      //   //中文简体
      //   this.customInfo.subtitleCn =  info.file.response.data.mediaUrl
      //   // this.$set(this.list[this.signleIndex],'subtitleCn',info.file.response.data.mediaUrl);
      //   updateGather(this.customInfo).then(res => {
      //     this.$emit("change")
      //   })
      //
      // }
      let that = this;
      if(this.customType == 2) {
        //繁體
        new UploadFileToVOD([info.file], {
          success: function (fileName) {
            console.log('上传成功回调', fileName)
            that.customInfo.subtitle = fileName[0];
            updateGather(that.customInfo).then(res => {
              that.$emit("change")
            })
            // this.$emit("change")
          },
        })

      }

      if(this.customType == 3) {
        //英文
        new UploadFileToVOD([info.file], {
          success: function (fileName) {
            console.log('上传成功回调', fileName)
            that.customInfo.subtitleEn = fileName[0];
            updateGather(that.customInfo).then(res => {
              that.$emit("change")
            })
            // this.$emit("change")
          },
        })
      }

      // if(this.customType == 4) {
      //   //马来
      //   this.customInfo.subtitleBm =  info.file.response.data.mediaUrl;
      //
      //   updateGather(this.customInfo).then(res => {
      //     this.$emit("change")
      //   })
      // }
      //
      // if(this.customType == 5) {
      //   //印尼
      //   this.customInfo.subtitleIn =  info.file.response.data.mediaUrl;
      //
      //   updateGather(this.customInfo).then(res => {
      //     this.$emit("change")
      //   })
      // }

    },
  }
}
</script>

<style scoped>

</style>